import type { FC, PropsWithChildren } from 'react'
import { Paper, useIsMobileVariant } from '@dhl-ui/components'

type PaperResponsiveProps = PropsWithChildren

/**
 * FIXME: candidate for central scope, untill clear which variants we have
 */
export const PaperResponsive: FC<PaperResponsiveProps> = ({ children }) => {
  const isMobileVariant = useIsMobileVariant()

  if (isMobileVariant) {
    return children
  }

  return (
    <Paper isOutlined isRounded>
      {children}
    </Paper>
  )
}
